/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useState } from "react";
import { NavigationContext } from "sections/navigation-context";
import { SimplicitySnackbar } from "components/snackbar";
import { useSnackbar } from "../hooks/useSnackbar";

const NavigationContextWrapper = (props) => {

    const { children } = props || {};
    const { showSnackbar } = useSnackbar();
    
    const [digitalAssetsTab, setDigitalAssetsTab] = useState(0);

    const section_tabs = [
        { id: 0, label: "Images" },
        { id: 1, label: "Documents" },
    ];
    const [imageTab, setImageTab] = useState(0);
    const image_tabs = [
        { id: 0, label: "Gallery" },
        { id: 1, label: "List" },
        { id: 2, label: "Upload" },
    ];
    const [documentTab, setDocumentTab] = useState(0);
    const document_tabs = [
        { id: 1, label: "List" },
        { id: 2, label: "Upload" },
    ];
    

    const navigationContext = {
        section_tabs,

        digitalAssetsTab,
        setDigitalAssetsTab,

        image_tabs,
        imageTab,
        setImageTab,

        document_tabs,
        documentTab,
        setDocumentTab,

        showSnackbar,
    };

    return (
        <>
            <NavigationContext.Provider value={navigationContext}>
                {children}
                <SimplicitySnackbar />
            </NavigationContext.Provider>
        </>
    );
};

export { NavigationContextWrapper };
